import { createDeviceId } from '@/shared/lib'

export const BOOTSTRAP = 'bootstraps'
export const deviceId = createDeviceId()
